export default __webpack_public_path__ + "static/media/UST-BUSD.13beab03.svg";